import { render } from "./wxlogin.vue?vue&type=template&id=076ee0ae&scoped=true&ts=true"
import script from "./wxlogin.vue?vue&type=script&lang=ts"
export * from "./wxlogin.vue?vue&type=script&lang=ts"

import "./wxlogin.vue?vue&type=style&index=0&id=076ee0ae&lang=less&scoped=true"

import exportComponent from "/web/CMES_Login_PC/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-076ee0ae"]])

export default __exports__